import { Link, useSearch } from '@tanstack/react-router';
import { useEffect, useRef, useState } from 'react';
import { api, errorMessage } from '../../lib/api';
import { cx } from '../../lib/cx';
import { useSession } from '../../lib/session';
import styles from './Auth.module.css';
import { AuthLayout } from './AuthLayout';

type State = { kind: 'verifying' } | { kind: 'verified' } | { kind: 'failed'; message: string };

export function VerifyEmailPage() {
  const { token } = useSearch({ strict: false }) as { token?: string };
  const { status, updateUser } = useSession();
  const [state, setState] = useState<State>({ kind: 'verifying' });
  const attempted = useRef<string | null>(null);

  useEffect(() => {
    if (!token) {
      setState({ kind: 'failed', message: 'Il link non è valido.' });
      return;
    }
    // Tokens work once: never send the same one twice.
    if (attempted.current === token) return;
    attempted.current = token;
    api.auth
      .verifyEmail({ token })
      .then(({ user }) => {
        if (status === 'signedIn') updateUser(user);
        setState({ kind: 'verified' });
      })
      .catch((error: unknown) => setState({ kind: 'failed', message: errorMessage(error) }));
  }, [token, status, updateUser]);

  const next =
    status === 'signedIn' ? <Link to="/oggi">Vai a oggi</Link> : <Link to="/login">Accedi</Link>;

  if (state.kind === 'verifying') return <AuthLayout title="Conferma in corso…">{null}</AuthLayout>;
  if (state.kind === 'verified') {
    return (
      <AuthLayout title="Email confermata" subtitle="Grazie, il tuo indirizzo è verificato.">
        <div className={styles.links}>{next}</div>
      </AuthLayout>
    );
  }
  return (
    <AuthLayout title="Conferma non riuscita">
      <p className={cx(styles.notice)} role="alert">
        {state.message}
      </p>
      <div className={styles.links}>{next}</div>
    </AuthLayout>
  );
}
